<button
  mat-icon-button
  [matMenuTriggerFor]="statusMenu"
  [disabled]="document.status === ClinicianCandidateDocumentStatus.PENDING || saving"
  [matTooltip]="'components.clinical-onboarding.document-action.change-status' | translate"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #statusMenu="matMenu">
  @if (document.returned_file_name && !document.is_immutable && document.status !== ClinicianCandidateDocumentStatus.VERIFIED) {
    <button mat-menu-item (click)="markAs(ClinicianCandidateDocumentStatus.VERIFIED)">
      <mat-icon>verified</mat-icon>
      <span>{{ 'components.clinical-onboarding.document-status.verified' | translate }}</span>
    </button>
  }
  @if (document.returned_file_name && !document.is_immutable && document.status !== ClinicianCandidateDocumentStatus.ANOMALY) {
    <button mat-menu-item (click)="markAs(ClinicianCandidateDocumentStatus.ANOMALY)">
      <mat-icon>error_outline</mat-icon>
      <span>{{ 'components.clinical-onboarding.document-status.anomaly' | translate }}</span>
    </button>
  }
  <!-- DBEK-411: invalida un documento gia' visionato/caricato/verificato -
       l'unica azione qui che si applica anche a un documento immutabile. -->
  @if (document.status !== ClinicianCandidateDocumentStatus.PENDING) {
    <button mat-menu-item (click)="invalidate()">
      <mat-icon>restart_alt</mat-icon>
      <span>{{ 'components.clinical-onboarding.document-action.invalidate' | translate }}</span>
    </button>
  }
</mat-menu>
@if (document.is_immutable) {
  <mat-icon
    class="immutable-lock-icon"
    [matTooltip]="'components.clinical-onboarding.document-action.immutable' | translate"
  >lock</mat-icon>
}
